import { fetchOneBox, fetchDevelopersOneBox, fetchOneBoxConfig, executeTroubleShoot, fetchRelatedSearches, executeSearch, getTopDocuments } from "./apiCalls";
import Utils from "./Customizations"
import { getProductFilterFieldByHost } from "./Utils";

const TROUBLESHOOT_CONFIDENCE_THRESHOLD = .7;

let HOST: string;

switch (window.location.host) {
  case "connect.redhat.com":
  case "kubebyexample.com":
  case "cloud.redhat.com":
  case "developers.redhat.com":
  case "docs.redhat.com":
    HOST = "access.redhat.com";
    break;

  case "connect.stage.redhat.com":
  case "stage.kubebyexample.com":
  case "cloud.stage.redhat.com":
  case "docs.stage.redhat.com":
    HOST = "access.stage.redhat.com";
    break;
  
  case "developers.stage.redhat.com":
    HOST = "access.redhat.com";
    break;

    case "connect.qa.redhat.com":
    case "qa.kubebyexample.com":
    case "cloud.qa.redhat.com":
    case "docs.qa.redhat.com":
      HOST = "access.qa.redhat.com";
      break;
  
  case "developers.qa.redhat.com":
    HOST = "access.stage.redhat.com";
    break;
  //TODO
  //create third case for QA
  //default to become window.location.host
  default:
    HOST = "access.redhat.com";
}

const matchTopDocumentsWithResults = (topDocuments, results) => {
  //these will be the links I get back from documents. They don't necessarily come back with prod env - could be QA or stage
  //so we want to split the URL so we are only looking at the second half of it and not caring about the env
  // let links = ["https://access.redhat.com/articles/6932811", "https://access.redhat.com/solutions/6821131", "https://access.redhat.com/products/red-hat-openshift-container-platform", "https://access.redhat.com/products/red-hat-openshift-container-platform/#getstarted"]
  let splitLinks = topDocuments?.links?.map(link => {
    return link.split(`https://access.redhat.com`).filter(f => f !== "")?.toString();
  });
  
  let simplifiedResults: {}[];
  simplifiedResults = [];
  let tempURL;

  results?.map(result => {
    let url = result?.view_uri 
    if (url?.includes('https://access.redhat.com')) {
      tempURL = result?.view_uri?.split(`https://access.redhat.com`);
    } else {
      tempURL = result?.view_uri?.split(`https://${HOST}`);
    }

    let titleToDisplay = result.allTitle ? result.allTitle : result.name ? result.name : result.title
    simplifiedResults.push({
      title: titleToDisplay,
      linkToDisplay: `https://access.redhat.com${tempURL[1]}`,
      linkToMatch: `${tempURL[1]}`
    });
  });

  interface PopularLink {
    text: string;
    link: string;
  };

  interface Listing {
    displayFeature: string;
    displayFeatureTitle: string;
    contentTitle: string;
    contentUrl: string;
    contentPositionRelative: string;
  };

  interface CardData {
    show: boolean;
    data: [];
    displayFeature: string;
    listings: Listing[];
  }

  interface Result {
    title: string;
    linkToDisplay: string;
    linkToMatch: string;
  }
  
  let cardData: CardData = {
    show: false,
    data: [],
    displayFeature: "",
    listings: []
  };

  let popularLinks: Array<PopularLink> = [];
  let popularLinksData;

  // @ts-ignore
  simplifiedResults?.forEach((result: Result) => {
    if (splitLinks?.includes(result?.linkToMatch)) {
      popularLinks.push({
        text: result?.title,
        link: result?.linkToDisplay
      });
    }
  });

  if (popularLinks.length === 0) {
    cardData.show = false;
  } else {
    popularLinksData = [{ title: "Popular with similar users", ...popularLinks }]
    cardData.show = true;
    cardData.data = popularLinksData;
    cardData.displayFeature = "Popular With Similar Users";
    cardData.listings = popularLinks?.map((popularLink: PopularLink, index) => {
      return {
        displayFeature: 'Popular With Similar Users',
        displayFeatureTitle:'Popular With Similar Users',
        contentTitle: popularLink?.text,
        contentUrl: popularLink?.link,
        contentPositionRelative: `${index + 1}`,
        contentID: popularLink?.link
      };
    });
  }
  
  return cardData;
};

export async function fetchAllData(query, settings) {
  const resultValues = [] as any[];
  const resultListings = [] as any[];
  const finalResultListings: any = [];
  let onSuccess
  let results
  let numResults
  let suggestions
  let documentKindFilters
  let topicFilters
  let productFilters
  let documentVersionFilters
  let topDocuments
  let facetInfo
  let topDocMatches

  const s = settings?.["executeSearchInput"]

  let apiCalls = {
    troubleshoot: () => executeTroubleShoot(query, HOST, TROUBLESHOOT_CONFIDENCE_THRESHOLD),
    oneBox: () => fetchOneBox(query, HOST),
    fetchDevelopersOneBox: () => fetchDevelopersOneBox(query, HOST),
    fetchOneBoxConfig: () => fetchOneBoxConfig(query, HOST),
    executeSearch: () => executeSearch(s?.["value"], HOST, s?.["rows"], s?.["pageNumber"], s?.["contentTypes"], s?.["version"], s?.["sort"], s?.["products"], s?.["topics"], s?.["listingDriver"], s?.["newSearch"], s?.["productVersionFilterQuery"], s?.["facetVersionSearchQuery"], s?.["currentSort"]),
    relatedSearches: () => fetchRelatedSearches(query, HOST),
    popWithSimilarUsers: () => getTopDocuments(query, HOST),
    
  }
  let fnCalls = Utils.getFnCalls()?.split(",")

 
  let promiseArr = fnCalls?.map(call => apiCalls[call]())
    
  //create the arr in this file
  //in env file have something like onebox,exectueSearch --> split on the comma and loop through to build the array of fn calls here
  
  return Promise.all(promiseArr).then(values => {
    values.forEach(value => {
      if(value?.onSuccess) {
        onSuccess = value?.onSuccess
        results = value?.docResults
        numResults = value?.response?.numFound
        suggestions = value?.suggestionsArr || []
        documentKindFilters = value?.facetsForContentTypes
        productFilters = value?.facetsForProducts
        topicFilters = value?.facetsForTopics
        documentVersionFilters = value?.facetsForDocumentVersions
        facetInfo = value?.facetInfo
      }

      if (value?.show) {
        if (!value.listings) {
          return;
        }

        value.listings.forEach(listing => resultListings.push(listing));
        resultValues.push({displayFeature: value?.displayFeature, data: value?.data});
      }

      if (value?.topDocuments) {
        topDocuments = value.topDocuments;
      }
    });

    if (topDocuments) {
      topDocMatches = matchTopDocumentsWithResults(topDocuments, results);
      topDocMatches?.listings?.forEach(listing => resultListings.push(listing));
      resultValues.push({displayFeature: topDocMatches?.displayFeature, data: topDocMatches?.data});
    }

    resultListings.forEach((listing, index) => listing.contentPosition = `${index + 1}`);

    //setting relative position for Natural search results
    resultValues.forEach(result => {
      if (result.displayFeature == "Natural") {
        for (let i = 0; i < result["data"].length; i++) {
          result.data[i].position = i + 1;
        }
      }
    });
    
    //check to see if no natural results are returned but recommended results are
    let recommendedWithoutNatural = false;
    let noNaturalResults = false;

    resultValues?.forEach(result => {
      if (result.displayFeature === "Natural" && result.data.length === 0) {
        noNaturalResults = true;
      }
      if (noNaturalResults && result.displayFeature === "Recommended" && result.data.length > 0) {
        recommendedWithoutNatural = true;
       }
    });

    //resultValuesAsList will contain each listing that we need to render that is different than our listings
    //arr for analytics -- ex: it has 1 OneBox value instead of 6
    //this arr will not be in order we are just getting the listings to render first
    let resultValuesAsList = [] as any

    resultValues?.forEach(result => {
      let currDisplayFeature = result.displayFeature;
      result["data"]?.forEach(res => {
        res.displayFeature = currDisplayFeature;
        resultValuesAsList.push(res);
      })
    });

    
    //finalResultListings will be an array of the listings we pass into Content Listing Displayed EDDL event 
    resultListings.forEach((listing, index) => {
      if (listing.displayFeature === "Natural" && listing.contentPositionRelative === "5") {
        finalResultListings.push(listing);
        for (let i = index; i < resultListings.length; i++) {
          if (resultListings[i].displayFeature === "Recommended") {
            finalResultListings.push(resultListings[i])
          }
        }
      //create conditon for when no natural search results but yes recommended
      } else if (listing.displayFeature === "Recommended" && recommendedWithoutNatural) {
        finalResultListings.push(listing);
      } else if (listing.displayFeature === "Recommended"){
        return;
      } else {
        finalResultListings.push(listing);
      }
    });

    //reset content position to account for Recommended Listings changing positioning when correct order is set
    let pos = 0;
    let oldFeature = ""

    let resultsForContentListingItemClicked = finalResultListings.map(listing => {
      let currFeature = listing.displayFeature; 

      if (currFeature !== oldFeature && currFeature !== "Natural") {
        pos++;
        oldFeature = currFeature;
      }
      if (listing.displayFeature == currFeature && listing.displayFeature !== "Natural") {
        listing.contentPosition = `${pos}`;
        return listing;
      } else if (listing.displayFeature === "Natural") {
        pos++;
        listing.contentPosition = `${pos}`;
        return listing;
      }
    })

    //create copy of abov for loops to create an array with results in order
    /*
     * need an array of the features in order
     * We need
     * - One Troubleshoot
     * - One OneBox
     * - All natural results
     * - One Recommended
     * - One Popular
     */
    //this arr will be resultValuesAsList but in order
    //it will be passed to ResultCards.tsx as the listings to render IN ORDER
    let resultValuesToRender = [] as any
    resultValuesAsList.forEach((result) => {

      if (result.displayFeature == "Natural" && result.position === 5) {
        resultValuesToRender.push(result);
        resultValuesAsList.forEach(r => {
          if (r.displayFeature == "Recommended") {
            resultValuesToRender.push(r);
          }
        })
      //create conditon for when no natural search results but yes recommended
       } else if (result.displayFeature == "Recommended"  && recommendedWithoutNatural) {
        resultValuesToRender.push(result);
      }
      else if (result.displayFeature == "Recommended") {
        return;
      }
       else {
        resultValuesToRender.push(result);
      }
      return resultValuesToRender
    });

    //constuct string for filterList for Content Listing Displayed analytics event    
    let filterListString = ""
    const filterUrl = new URLSearchParams(window.location.search);
    const productVersionFromUrl = filterUrl.get('documentation_version') || ""
    let contentTypeFilterFromUrl = filterUrl.get('documentKind') || "";
    const productFilterField = getProductFilterFieldByHost();
    let productFilterFromUrl = filterUrl.get('product') || "";
    let topicFilterFromUrl = filterUrl.get('topic') || "";

    if (contentTypeFilterFromUrl.length > 0) {
      contentTypeFilterFromUrl = contentTypeFilterFromUrl?.split("&")?.join("|documentKind~");
      filterListString += `documentKind~${contentTypeFilterFromUrl}`;
    }
    if (productFilterFromUrl.length > 0) {
      productFilterFromUrl = productFilterFromUrl.split("&").join(`|${productFilterField}~`);
      if (filterListString.length == 0) {
        filterListString += `${productFilterField}~${productFilterFromUrl}`;
      } else {
        filterListString += `|${productFilterField}~${productFilterFromUrl}`;
      }
    }

    if (topicFilterFromUrl.length > 0) {
      topicFilterFromUrl = topicFilterFromUrl.split("&").join("|topic~");
      if (filterListString.length == 0) {
        filterListString += `topic~${topicFilterFromUrl}`;
      } else {
        filterListString += `|topic~${topicFilterFromUrl}`;
      }
    }

    if (productVersionFromUrl.length > 0) {
      let formattedVersions = productVersionFromUrl?.split("&").filter(f => f !== "");
      let versionList = "";
      for (let i = 0; i < formattedVersions.length; i+=2) {
        let currVersions = formattedVersions[i+1]?.split(",");
        for (let j = 0; j < currVersions?.length; j++) {
          if (currVersions[j] !== "") {
              versionList += `|documentation-version~${formattedVersions[i]}-${currVersions[j]}`;
          }
      
        }
      }
      filterListString += versionList;
    }

    let naturalCardsData = {results: results,
       numResults: numResults,
       suggestions: suggestions,
       documentKindFilters: documentKindFilters,
       productFilters: productFilters,
       topicFilters: topicFilters,
       documentVersionFilters: documentVersionFilters,
      //  topDocuments: topDocuments,
       facetInfo: facetInfo
    }

    // add content key for resultsForContentListingItemClicked
    let finalResultListingsForEddl = resultsForContentListingItemClicked.map(listing => {
      return {content: listing}
    })
    if(Utils.getHostUrl() !== "offline-portal"){
    //@ts-ignore
    window.appEventData = window.appEventData || [];
    //@ts-ignore
    appEventData.push({
      "event": "Content Listing Displayed",
      "listingDisplayed": {
        "filterList": filterListString,
        "listing": finalResultListingsForEddl,
        "listingDriver": s?.["listingDriver"] === "" ? "Onsite Search" : s?.["listingDriver"],
        "listingType": "content",
        "resultsCount": `${numResults}`,
        "displayCount": `${resultValuesToRender?.length}`,
        "sortOrder": s?.["currentSort"] === "" ? "Most Relevant" : s?.["currentSort"]
      }
    });
  }

    return {resultValuesToRender, resultsForContentListingItemClicked, onSuccess, naturalCardsData}
  });
}
